import { render } from "./log-in.vue?vue&type=template&id=2419b4ca"
import script from "./log-in.vue?vue&type=script&lang=js"
export * from "./log-in.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/thecompcodes-dashboard/thecompcodes-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__